import React from "react";
import styled, { createGlobalStyle, css } from "styled-components";
import "react-responsive-modal/styles.css";
import { Modal as ReactModal } from "react-responsive-modal";
import ButtonImage from "./ButtonImage";
import { ReactComponent as CloseSVG } from "../assets/svg/close.svg";

const ModalForm = ({ title = "", children = undefined, isOpen, onClose = () => {}, ...rest }) => {
  return (
    <>
      <GlobalStyles />
      <ReactModal
        closeOnOverlayClick={false}
        open={isOpen}
        showCloseIcon={false}
        onClose={onClose}
        classNames={{
          overlay: "customOverlay",
          modal: "customModal",
        }}
        {...rest}
      >
        <ModalContainer>
          <Header>
            <Title>{title}</Title>
            <ButtonImage
              type="secondary"
              iconSVG={CloseSVG}
              onClick={onClose}
            />
          </Header>
          {children}
        </ModalContainer>
      </ReactModal>
    </>
  );
};

const ModalContainer = styled.div``;

const GlobalStyles = createGlobalStyle`
  @media (min-width: 501px) {
    .customModal {
      border-radius: 15px;
      border: 1px solid #ccc;
      padding: 25px;
      overflow-y: visible;
    }

    ${ModalContainer} {
      max-width: 500px;
      width: 80vw;
    }
  }

  @media (max-width: 500px) {
    .customModal {
      box-sizing: border-box;
      height: 100%;
      width: 100%;
      margin: 0;
    }

    ${ModalContainer} {
      width: 100%;
    }
  }
`;

const Title = styled.div`
  display: flex;
  align-items: center;

  font-size: 1.2em;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 35px;
`;

export default ModalForm;
